import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { StoredHotelBookingData } from "src/store/slices/hotels/Hotels";
import { SearchFormInputs } from "../../constants/SearchPage";
import HotelDetails from "./HotelDetails";

export type HotelDetailsLoaderData = StoredHotelBookingData & {
  searchObject: SearchFormInputs;
  numberOfNights: number;
  selectedBookingCode: string | null;
};

export default function HotelDetailsLoader() {
  const { hotelKey, hotelDetailsKey } = useParams();

  const data = useMemo<HotelDetailsLoaderData | null>(() => {
    const hotelDataString = localStorage.getItem(`${hotelKey}`);
    const hotelRoomDataString = localStorage.getItem(`${hotelDetailsKey}`);
    if (!hotelDataString || !hotelRoomDataString) return null;

    try {
      const parsed: HotelDetailsLoaderData = JSON.parse(hotelRoomDataString);
      if (!parsed.hotel) return null;
      return parsed;
    } catch {
      return null;
    }
  }, [hotelKey, hotelDetailsKey]);

  if (!data) return <Navigate to="/not-found" replace />;
  return <HotelDetails hotelRoomData={data} />;
}
